import cookies from "js-cookie";
import { Duration } from "luxon";
import { SESSION_TOKEN_DURATION } from "./token";
import { COOKIE_KEYS } from "./cookieKeys";

export { COOKIE_KEYS } from "./cookieKeys";

export enum HEADER_KEYS {
  API_KEY = "x-api-key",
  AUTHORIZATION = "authorization",
  COMPLIANCE_EXCLUSION_TAGS = "x-dream-cet",
  EXCLUDED_PROGRAM_IDS = "x-dream-excluded-program-ids",
  EXPERIMENTS = "x-dream-experiments",
  HREF = "x-dream-href",
  GPC = "x-dream-gpc",
  INTROSPECTION_KEY = "x-dream-introspection-key",
  // `/api/mixpanel` and `/api/engagement` drop every request carrying this flag, including
  // business events, so the snippet must flag only crawler and data-center traffic, never a
  // bot-score guess about a person.
  IS_BOT = "x-dream-is-bot", // Is added to request via Cloudflare snippet (https://dash.cloudflare.com/098f0ea7a87718a6bfcaafc49a0505f7/dreambound.com/rules/snippets)
  IS_MUTATION = "x-dream-is-mutation",
  IS_TEST = "x-dream-test",
  // Set by proxy.ts (never trusted from the client) when the User-Agent is a crawler that
  // only consumes <head> metadata, so page bodies can skip rendering. See
  // the metadataOnly policy in app/_common/lib/crawlers.ts.
  METADATA_ONLY_CRAWLER = "x-dream-metadata-only",
  // Reserved for a Cloudflare request-header transform from cf.verified_bot_category.
  // It is sanitized by proxy.ts but intentionally ignored for crawler classification until
  // the carrier has authenticated edge provenance.
  VERIFIED_BOT_CATEGORY = "x-dream-verified-bot-category",
  OPERATION_NAME = "x-dream-operation-name",
  REDIRECT = "x-dream-redirect",
  REFRESH_TOKEN = "x-dream-refresh-token",
  REFERRER = "referrer",
  SSR_ATTESTATION = "x-dream-ssr-attestation",
  APOLLO_CLIENT_NAME = "apollographql-client-name",
  APOLLO_CLIENT_VERSION = "apollographql-client-version",
  JOBS_API_KEY = "x-jobs-api-key",
  TYPESENSE_API_KEY = "x-typesense-api-key",
  CF_CONNECTING_IP = "cf-connecting-ip",
  CF_IPZIP = "cf-ipzip",
  CF_IPCITY = "cf-ipcity",
  CF_IPSTATE = "cf-ipstate",
  CF_IPCOUNTRY = "cf-ipcountry",
  CF_IPLONGITUDE = "cf-iplongitude",
  CF_IPLATITUDE = "cf-iplatitude",
  CF_POSTAL_CODE = "cf-postal-code",
  CF_REGION_CODE = "cf-region-code",
  CF_TIMEZONE = "cf-timezone",
  CF_METRO_CODE = "cf-metro-code",
  CF_REGION = "cf-region",
}

export const getCookie = (cookie: COOKIE_KEYS) => cookies.get(cookie);

const secure = !!process.env.DREAM_PORTAL_URL?.includes("https");
export const setCookie = (cookie: COOKIE_KEYS, value: string, options?: { expires?: number }) =>
  cookies.set(cookie, value, {
    expires: options?.expires ?? Duration.fromObject(SESSION_TOKEN_DURATION).days,
    path: "/",
    sameSite: "lax",
    secure,
  });

export const deleteCookie = (cookie: COOKIE_KEYS) =>
  cookies.set(cookie, "", {
    expires: -99999999,
    path: "/",
    sameSite: "lax",
    secure,
  });
